export default __webpack_public_path__ + "static/media/catwikilogo.92dea8ab.svg";